import type { State } from '../../types';
import type { TaskViewModel } from '@trinnvis/dabih-api-client';

import { toList } from '../toList';

export function tasksDeleted(state: State): TaskViewModel[] {
  if (state.organization === undefined) return [];
  return toList(state.organization.tasksById).filter((e) => e.deleted);
}
